exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{box-sizing:border-box;margin:0;padding:0}table{border-collapse:collapse}table,td,th{border:1px solid #000;padding:5px}html{font-size:10px}a,body,h1,h2,h3,h4,h5,h6,li,p,ul{font-family:Avenir,Helvetica Neue,sans-serif}dl,h1,h2,h3,h4,h5,h6,ol,p,ul{margin:30px 0}dd,dt,li,li>*{margin:10px 0}code,pre{font-family:Space Mono,monospace}h1{font-size:4rem}h2{font-size:3.5rem}h3{font-size:3rem}h4{font-size:2.4rem}h5{font-size:2rem}h6{font-size:1.6rem}a,dd,dt,li,p,th,tr{font-size:1.8rem}a{color:#2973b7;text-decoration:none}a:hover{border-bottom:1px solid #000}blockquote{border-left:5px solid #959191;font-style:italic;padding-left:18px}.book-blurb{background-color:#f6f6f6;font-style:normal;padding:25px;text-align:center;margin-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/layouts/css/index.css
// module id = ./src/layouts/css/index.css
// module chunks = 5217438866945042000